import IconEarlyCheckInOrOut from "../assets/icons/IconEarlyCheckInOrOut"
import IconWelcomeDrink from "../assets/icons/IconWelcomeDrink"
import IconFreeBreakfast from "../assets/icons/IconFreeBreakfast"
import IconSpaAccess from "../assets/icons/IconSpaAccess"
import IconSpaTreatments from "../assets/icons/IconSpaTreatments"
import IconLoyaltyProgram from "../assets/icons/IconLoyaltyProgram"
import IconRestaurantDiscount from "../assets/icons/IconRestaurantDiscount"
import IconFreeParking from "../assets/icons/IconFreeParking"
import IconRoomUpgrade from "../assets/icons/IconRoomUpgrade"
import IconWelcomeKit from "../assets/icons/IconWelcomeKit"
import IconPoolIncluded from "../assets/icons/IconPoolIncluded"
import IconBeachIncluded from "../assets/icons/IconBeachIncluded"
import IconFlexibility from "../assets/icons/IconFlexibility"
import IconFreeMinibar from "../assets/icons/IconFreeMinibar"
import IconBoatTour from "../assets/icons/IconBoatTour"
import IconFreeExperiences from "../assets/icons/IconFreeExperiences"
import IconFreeExcursions from "../assets/icons/IconFreeExcursions"
import IconFreeAttractions from "../assets/icons/IconFreeAttractions"
import IconTrentinoCard from "../assets/icons/IconTrentinoCard"
import IconPremiumExperiences from "../assets/icons/IconPremiumExperiences"
import IconFreeWifi from "../assets/icons/IconFreeWifi"
import IconGuidedTour from "../assets/icons/IconGuidedTour"
import IconFreeCancellation from "../assets/icons/IconFreeCancellation"
import IconGreenFormula from "../assets/icons/IconGreenFormula"
import IconCustomizedPackages from "../assets/icons/IconCustomizedPackages"

export type Advantage = "lowest_price" |
"early_checkin" |
"late_checkout" |
"welcome_drink" |
"free_breakfast" |
"spa_access" |
"spa_treatments" |
"loyalty_program" |
"restaurant_discount" |
"free_parking" |
"upgrade_upon_availability" |
"vip_welcome_amenity" |
"pool_included" |
"beach_included" |
"flexibility" |
"free_minibar" |
"boat_tour" |
"free_experiencies" |
"free_excursions" |
"free_attractions" |
"trentino_card" |
"premium_experiences" |
"free_wifi" |
"guided_tour" |
"free_cancellation" |
"green_formula" |
"customized_packages" |
"resellable_rate"

export const advantagesMap = {
  "early_checkin": {
    label: "ds.early_checkin",
    icon: IconEarlyCheckInOrOut
  },
  "late_checkout": {
    label: "ds.late_checkout",
    icon: IconEarlyCheckInOrOut
  },
  "welcome_drink": {
    label: "ds.welcome_drink",
    icon: IconWelcomeDrink
  },
  "free_breakfast": {
    label: "ds.free_breakfast",
    icon: IconFreeBreakfast
  },
  "spa_access": {
    label: "ds.spa_access",
    icon: IconSpaAccess
  },
  "spa_treatments": {
    label: "ds.spa_treatments",
    icon: IconSpaTreatments
  },
  "loyalty_program": {
    label: "ds.loyalty_program",
    icon: IconLoyaltyProgram
  },
  "restaurant_discount": {
    label: "ds.restaurant_discount",
    icon: IconRestaurantDiscount
  },
  "free_parking": {
    label: "ds.free_parking",
    icon: IconFreeParking
  },
  "upgrade_upon_availability": {
    label: "ds.upgrade_upon_availability",
    icon: IconRoomUpgrade
  },
  "vip_welcome_amenity": {
    label: "ds.vip_welcome_amenity",
    icon: IconWelcomeKit
  },
  "pool_included": {
    label: "ds.pool_included",
    icon: IconPoolIncluded
  },
  "beach_included": {
    label: "ds.beach_included",
    icon: IconBeachIncluded
  },
  "flexibility": {
    label: "ds.flexibility",
    icon: IconFlexibility
  },
  "free_minibar": {
    label: "ds.free_minibar",
    icon: IconFreeMinibar
  },
  "boat_tour": {
    label: "ds.boat_tour",
    icon: IconBoatTour
  },
  "free_experiencies": {
    label: "ds.free_experiencies",
    icon: IconFreeExperiences
  },
  "free_excursions": {
    label: "ds.free_excursions",
    icon: IconFreeExcursions
  },
  "free_attractions": {
    label: "ds.free_attractions",
    icon: IconFreeAttractions
  },
  "trentino_card": {
    label: "ds.trentino_card",
    icon: IconTrentinoCard
  },
  "premium_experiences": {
    label: "ds.premium_experiences",
    icon: IconPremiumExperiences
  },
  "free_wifi": {
    label: "ds.free_wifi",
    icon: IconFreeWifi
  },
  "guided_tour": {
    label: "ds.guided_tour",
    icon: IconGuidedTour
  },
  "free_cancellation": {
    label: "ds.free_cancellation",
    icon: IconFreeCancellation
  },
  "green_formula": {
    label: "ds.green_formula",
    icon: IconGreenFormula
  },
  "customized_packages": {
    label: "ds.customized_packages",
    icon: IconCustomizedPackages
  },
  "resellable_rate": {
    label: "ds.resellable_rate",
    icon: IconFlexibility
  }
} as const